<template>
	<layout-page-v2 class="appointment-calendar" icon="sethoscope" :h1="$t('base.watch.appointments')" :h2="$t('base.watch.calendar')">
		<div slot="btn-group" class="btn-group">
			<button-icon-text-loading @click.native="openModal({ action: 'add' })" icon="plus-w" class="plus btn-add">{{ $t('buttons.actions.add_appointment') }}</button-icon-text-loading>
		</div>
		<appointment-navigation :user_uid="user_uid" :watch_id="watch_id"/>
		<error-box v-if="appointments.error" :error="appointments.error"/>
		<div class="calendar-container">
			<spinner v-if="appointments.loading" class="center"/>
			<vue-calendar :events="events" @day-clicked="dayClicked" @event-clicked="eventClicked" @month-changed="monthChanged"/>
		</div>
		<appointment-form v-if="modalBox.open" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</layout-page-v2>
</template>

<script>
import AppointmentNavigation from './AppointmentNavigation'
import AppointmentForm from './AppointmentForm'
export default {
	components: {
		AppointmentNavigation,
		AppointmentForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			appointments: {
				loading: false,
				data: [],
				error: null
			},
			modalBox: {
				open: false,
				params: {}
			},
			startDate: '',
			endDate: ''
		}
	},
	computed: {
		events () {
			const events = []
			this.appointments.data.forEach(element => {
				events.push({
					title: `${element.name} ${this.$moment(element.date).format('HH:mm')}`,
					start: new Date(element.date),
					end: null,
					event: element
				})
			})
			return events
		}
	},
	methods: {
		dayClicked (day) {
			const date = this.$moment(day.date).format('YYYY-MM-DD')
			this.openModal({ action: 'add', date })
		},
		eventClicked (event) {
			this.openModal({ action: 'edit', id: event.event.id })
		},
		monthChanged (start, end) {
			this.startDate = this.$moment(start).subtract(1, 'w').format()
			this.endDate = this.$moment(end).add(1, 'w').format()
			this.getAppointments(this.startDate, this.endDate)
		},
		getAppointments (date_start, date_end) {
			this.appointments.loading = true
			this.appointments.data = []
			this.clearStyleDaysWithEvents()
			this.$api.appointments.getAllByDates(this, this.user_uid, this.watch_id, date_start, date_end).then(response => {
				this.$log.info('watch appointments', 'appointments.getAllByDates OK', response)()
				this.appointments.data = response.body
			}).catch(errors => {
				this.$log.error('watch appointments', 'appointments.getAllByDates ERROR', errors)()
				this.appointments.error = errors
			}).finally(() => {
				this.appointments.loading = false
				this.styleDaysWithEvents()
			})
		},
		styleDaysWithEvents () {
			this.$nextTick(function () {
				let elements, i;
				elements = document.querySelectorAll('.events')
				for (i = 0; i < elements.length; i++) {
					elements[i].parentElement.classList.add('has-events')
				}
			})
		},
		clearStyleDaysWithEvents () {
			this.$nextTick(function () {
				let elements, i;
				elements = document.querySelectorAll('.has-events')
				for (i = 0; i < elements.length; i++) {
					elements[i].classList.remove('has-events')
				}
			})
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.getAppointments(this.startDate, this.endDate)
			}
		}
	},
	beforeCreate () {
		this.$title('Month Calendar')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/appointments/AppointmentCalendar.vue